module.exports = __webpack_public_path__ + "img/rays.0ee13fe0.png";